import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1415.37671,2.27373675e-13 L505.585796,2.27373675e-13 C411.536161,2.27373675e-13 335,76.5361606 335,170.585796 L335,1920 L960.481253,1544.71125 L1585.96251,1920 L1585.96251,170.585796 C1585.96251,76.5361606 1509.42635,2.27373675e-13 1415.37671,2.27373675e-13 L1415.37671,2.27373675e-13 Z M1472.23864,1719.16366 L960.481253,1412.10922 L448.723864,1719.16366 L448.723864,170.585796 C448.723864,139.19801 474.19801,113.723864 505.585796,113.723864 L1415.37671,113.723864 C1446.7645,113.723864 1472.23864,139.19801 1472.23864,170.585796 L1472.23864,1719.16366 Z M1241.95919,538.16407 L1161.44269,457.761298 L960.492626,658.82509 L759.428834,457.761298 L679.026062,538.16407 L880.089854,739.227862 L679.026062,940.17793 L759.428834,1020.5807 L960.492626,819.630634 L1161.44269,1020.5807 L1241.95919,940.17793 L1040.8954,739.227862 L1241.95919,538.16407 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconRemoveBookmarkLine = /*#__PURE__*/function (_Component) {
  _inherits(IconRemoveBookmarkLine, _Component);

  var _super = _createSuper(IconRemoveBookmarkLine);

  function IconRemoveBookmarkLine() {
    _classCallCheck(this, IconRemoveBookmarkLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconRemoveBookmarkLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconRemoveBookmark",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconRemoveBookmarkLine.displayName = "IconRemoveBookmarkLine";
  return IconRemoveBookmarkLine;
}(Component);

IconRemoveBookmarkLine.glyphName = 'remove-bookmark';
IconRemoveBookmarkLine.variant = 'Line';
IconRemoveBookmarkLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconRemoveBookmarkLine;
export { IconRemoveBookmarkLine };